import { api } from "../../api/api";
import socket from "../../socket"; // 싱글톤 소켓 임포트
import {
  GET_PLAYLIST_SUCCESS,
  ADD_PLAYLIST_SUCCESS,
  ADD_PLAYLIST_REQUEST,
  DELETE_CONTENT_FROM_PLAYLIST,
  UPDATE_DURATION,
  DELETE_PLAYLIST,
  PLAYLIST_SCREEN_CHECK,
  ADD_CONTENT_IN_PLAYLIST,
  GET_PLAYLIST_REQUEST,
  GET_PLAYLIST_FAILED,
  PLAYLIST_FLAG_OFF,
  PLAYLIST_SCHEDULE_SUCCESS,
  PLAYLIST_SCHEDULE_DELETE,
} from "../constant";

export const playlistFlagOff = () => {
  return async (dispatch) => {
    dispatch({ type: PLAYLIST_FLAG_OFF, payload: "" });
  };
};

export const addPlaylist = (data) => {
  return async (dispatch) => {
    dispatch({ type: ADD_PLAYLIST_REQUEST, payload: "" });
    const playlist = await api.post(`/playlist/add`, data);
    if (playlist.status === 201) {
      dispatch({ type: ADD_PLAYLIST_SUCCESS, payload: playlist.data.playlist });
    }
  };
};

export const getPlaylist = (userId) => {
  return async (dispatch) => {
    if (userId == null || userId === '') return;
    dispatch({ type: GET_PLAYLIST_REQUEST, payload: "" });
    try {
      const playlist = await api.get(`/playlist/getplaylist/${userId}`);
      if (playlist.status === 200) {
        const list = Array.isArray(playlist.data?.playlist) ? playlist.data.playlist : [];
        if (Array.isArray(playlist.data?.playlist)) {
          dispatch({ type: GET_PLAYLIST_SUCCESS, payload: list });
        } else {
          dispatch({ type: GET_PLAYLIST_FAILED, payload: playlist.data?.message || "" });
        }
      }
    } catch (err) {
      dispatch({ type: GET_PLAYLIST_FAILED, payload: "" });
    }
  };
};

export const addContentInPlaylist = (obj) => {
  return async (dispatch) => {
    const playlist = await api.patch(
      `/playlist/addcontent/${obj.id}`,
      { content: obj.value }
    );
    if (playlist.status === 201) {
      dispatch({
        type: ADD_CONTENT_IN_PLAYLIST,
        payload: playlist.data.playlist,
      });
      // 플레이리스트를 사용 중인 TV 기기에 실시간 알림 전송
      if (obj.mac) {
        socket.emit('playlist_added', { detail: { mac: obj.mac } });
      }
    }
  };
};

export const playlistScreenCheck = (obj) => {
  return async (dispatch) => {
    dispatch({ type: PLAYLIST_SCREEN_CHECK, payload: obj });
  };
};

export const deleteContentFromPlaylist = (obj) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CONTENT_FROM_PLAYLIST, payload: obj });
    await api.patch(
      `/playlist/deletecontentfromplaylist/${obj.playlistId}`,
      { contentId: obj.contentId }
    );
    // 콘텐츠 삭제 후 TV 기기 실시간 업데이트
    if (obj.mac) {
      socket.emit('content_deleted', { detail: { mac: obj.mac } });
    }
  };
};

export const deletePlaylist = (id) => {
  return async (dispatch) => {
    const playlist = await api.get(`/playlist/deleteplaylist/${id}`);
    if (playlist.status === 200) {
      dispatch({ type: DELETE_PLAYLIST, payload: playlist.data.playlist });
    }
  };
};

export const updateDuration = (obj) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_DURATION, payload: obj });
    await api.patch(`/playlist/updateduration/${obj.playlistId}`, {
      time: obj.time,
      contentId: obj.contentId,
    });
    // 재생 시간 변경 시 TV 기기 실시간 업데이트
    if (obj.mac) {
      socket.emit('update_duration', { detail: { mac: obj.mac } });
    }
  };
};

export const updatePlaylist = (pid, cid, obj) => {
  return async (dispatch) => {
    const updated = await api.patch(`/playlist/schedule/${pid}/${cid}`, obj);
    if (updated.status === 200) {
      dispatch({ type: PLAYLIST_SCHEDULE_SUCCESS, payload: updated.data.updated });
    }
  };
};

export const deletePlaylistSchedule = (pid, cid) => {
  return async (dispatch) => {
    const updated = await api.patch(`/playlist/deletecontentschedule/${pid}/${cid}`);
    if (updated.status === 200) {
      dispatch({ type: PLAYLIST_SCHEDULE_DELETE, payload: updated.data.updated });
    }
  };
};
